<div class="d-flex flex-wrap gap-4 gap-lg-2 mb-3 justify-content-evenly justify-content-lg-between align-items-center">
  <button *ngFor="let amount of amountsMonthly" type="button" class="btn py-3 py-lg-2"
    [class.btn-outline-primary]="selected !== amount" [class.btn-primary]="selected === amount"
    (click)="selectAmount(amount)">
    ${{ amount }}
  </button>
</div>
